module.exports = __webpack_public_path__ + "static/media/sgd-12.4875d59a.png";